<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
@Component({
  name: UploadDocumentsModel,
})
export default class UploadDocumentsModel extends Vue {}
</script>

<style></style>
